import { eduIDApi } from "./common";
export const personalDataApi = eduIDApi.injectEndpoints({
    endpoints: (builder) => ({
        postUserName: builder.mutation({
            query: (body) => ({
                url: "user/name",
                body,
            }),
            extraOptions: { service: "personalData" },
        }),
        postUserLanguage: builder.mutation({
            query: (body) => ({
                url: "user/language",
                body,
            }),
            extraOptions: { service: "personalData" },
        }),
        requestAllPersonalData: builder.query({
            query: () => ({
                url: "all-user-data",
            }),
            extraOptions: { service: "personalData" },
        }),
        postSecurityKeyPreference: builder.mutation({
            query: (body) => ({
                url: "preferences",
                body,
            }),
            extraOptions: { service: "personalData" },
        }),
    }),
});
export default personalDataApi;
